import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import ProjectGroups from './pages/ProjectGroups';
import Projects from './pages/Projects';
import ProjectDetail from './pages/ProjectDetail';
import ProjectGroupDetail from './pages/ProjectGroupDetail';
import Tasks from './pages/Tasks';
import SignUp from './pages/auth/SignUp';
import Login from './pages/auth/Login';
import ForgotPassword from './pages/auth/ForgotPassword';
import ResetPassword from './pages/auth/ResetPassword';
import Profile from './pages/Profile';
import Preferences from './pages/Preferences';
import PrivateRoute from './components/common/PrivateRoute';
import { ToastProvider } from './contexts/ToastContext';
import { AuthProvider } from './contexts/AuthContext';
import { AvatarProvider } from './contexts/AvatarContext';
import { FeatureFlagsProvider } from './contexts/FeatureFlagsContext';
import { useSignUpFeature } from './hooks/useFeatureFlags';
import './App.css';

// App content component that uses the feature flags
const AppContent = () => {
  const { isSignUpEnabled } = useSignUpFeature();
  
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex flex-col">
      <Router>
        <Navbar />
        <main className="flex-1 pt-16 pb-16">
          <Routes>
            {isSignUpEnabled && <Route path="/sign-up" element={<SignUp />} />}
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            <Route path="/" element={<PrivateRoute><Home /></PrivateRoute>} />
            <Route path="/project-groups" element={<PrivateRoute><ProjectGroups /></PrivateRoute>} />
            <Route path="/projects" element={<PrivateRoute><Projects /></PrivateRoute>} />
            <Route path="/project/:id" element={<PrivateRoute><ProjectDetail /></PrivateRoute>} />
            <Route path="/project-group/:id" element={<PrivateRoute><ProjectGroupDetail /></PrivateRoute>} />
            <Route path="/tasks" element={<PrivateRoute><Tasks /></PrivateRoute>} />
            <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
            <Route path="/preferences" element={<PrivateRoute><Preferences /></PrivateRoute>} />
          </Routes>
        </main>
        <Footer />
      </Router>
    </div>
  );
};

function App() {
  return (
    <FeatureFlagsProvider>
      <AuthProvider>
        <AvatarProvider>
          <ToastProvider>
            <AppContent />
          </ToastProvider>
        </AvatarProvider>
      </AuthProvider>
    </FeatureFlagsProvider>
  );
}

export default App;